import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { CorporativeClientService } from '@rsm/client/corporative-client';
import {
  catchError,
  distinctUntilChanged,
  filter,
  of,
  Subject,
  switchMap,
  takeUntil,
} from 'rxjs';
import { CompanySetupService } from '../../company-setup.service';

@Component({
  selector: 'app-company-setup-address',
  templateUrl: './company-setup-address.component.html',
  styleUrls: ['./company-setup-address.component.scss'],
})
export class CompanySetupAddressComponent implements OnInit, OnDestroy {
  addressForm: FormGroup = this.companySetupService.addressForm;

  onDestroy$ = new Subject<void>();

  private readonly districtLabels: Record<string, string> = {
    DF: 'Região Administrativa',
    GO: 'Setor/Bairro',
  };

  constructor(
    private companySetupService: CompanySetupService,
    private corporativeService: CorporativeClientService
  ) {}

  ngOnInit(): void {
    this.updateAddressOnCepChange();
  }

  get districtLabel(): string {
    const uf = this.addressForm.get('uf')?.value?.toUpperCase();
    return this.districtLabels[uf] ?? 'Bairro';
  }

  updateAddressOnCepChange() {
    this.addressForm
      .get('cep')
      .valueChanges.pipe(
        takeUntil(this.onDestroy$),
        filter((cep) => cep && cep?.length === 8),
        distinctUntilChanged(),
        switchMap((cep) =>
          this.corporativeService
            .getAddressFromCEP(cep)
            .pipe(catchError(() => of(null)))
        )
      )
      .subscribe((address: any) => {
        if (!address) return;
        this.addressForm.patchValue({
          uf: address.uf,
          city: address.localidade,
          district: address.bairro,
          logradouro: address.logradouro,
          complemento: address.complemento ?? null,
        });
      });
  }

  get controls(): any {
    return this.addressForm.controls;
  }

  ngOnDestroy(): void {
    this.onDestroy$.next();
    this.onDestroy$.complete();
  }
}
